import { render } from "./ModalAddUsuario.vue?vue&type=template&id=5e2d4290"
import script from "./ModalAddUsuario.vue?vue&type=script&lang=js"
export * from "./ModalAddUsuario.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__